import React, { useEffect } from "react";

// Import bootstrap classes
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

// Import icon classes
import './assets/fonts/fontawesome-pro-6.5.0-web/css/all.min.css'

// Import carousel style
import 'react-multi-carousel/lib/styles.css';

// Import modal style
import 'react-responsive-modal/styles.css';

// Lazy load style
// import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

// Import pagination style
import 'react-responsive-pagination/themes/classic.css';

// Import date range style
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

// Import quill editor style
import 'react-quill/dist/quill.snow.css';

// Import toast component
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// Import date picker style
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

// Import style
import './assets/styles/style.css'

// Route dom librairies
import { BrowserRouter } from 'react-router-dom';

// Get token
import { getAuthToken } from "./api/auth";

// Import components and views
import UserRoutesWithAnimation from "./UserRoutesWithAnimation";
import AdminRoutes from "./AdminRoutes";
import { initializeWeglot } from "./constants/functions";



const App = () => {

  const token = getAuthToken(); 

  useEffect(() => {
    initializeWeglot();
  }, [])

  return (
    <BrowserRouter>
      {token && <AdminRoutes />}
      <UserRoutesWithAnimation/>

      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
